import { useEffect } from "react";

type BookingModalProps = {
  open: boolean;
  scheduleUrl: string;
  onClose: () => void;
};

/**
 * Modal shell for Google Calendar Appointment Scheduling iframe.
 */
export function BookingModal({
  open,
  scheduleUrl,
  onClose,
}: BookingModalProps) {
  useEffect(() => {
    if (!open) return;

    function onKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") onClose();
    }

    document.addEventListener("keydown", onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open || !scheduleUrl) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-label="Book a consultation session"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-3xl overflow-hidden rounded-xl bg-white shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 z-10 flex size-8 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition-colors hover:bg-slate-200"
          aria-label="Close booking calendar"
        >
          ×
        </button>

        <div className="flex flex-col items-center">
          <iframe
            src={scheduleUrl}
            style={{ border: 0 }}
            width="100%"
            height="600"
            frameBorder={0}
            title="Google Calendar Appointment Scheduling"
          />
        </div>
      </div>
    </div>
  );
}
